/* tslint:disable */
/* eslint-disable */
/**
 * KNMI exons API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface ParametersGeoCoordinates
 */
export interface ParametersGeoCoordinates {
    /**
     * 
     * @type {string}
     * @memberof ParametersGeoCoordinates
     */
    'type': ParametersGeoCoordinatesTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ParametersGeoCoordinates
     */
    'latitude': number;
    /**
     * 
     * @type {number}
     * @memberof ParametersGeoCoordinates
     */
    'longitude': number;
}

export const ParametersGeoCoordinatesTypeEnum = {
    Coordinates: 'Coordinates'
} as const;

export type ParametersGeoCoordinatesTypeEnum = typeof ParametersGeoCoordinatesTypeEnum[keyof typeof ParametersGeoCoordinatesTypeEnum];


